export default __webpack_public_path__ + "static/media/logo_1_white.a563e7f7.png";